import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { ArrowRight, CheckCircle2 } from 'lucide-react';

const VideoPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "https://fast.wistia.com/player.js";
    script1.async = true;
    document.body.appendChild(script1);

    const script2 = document.createElement("script");
    script2.src = "https://fast.wistia.com/embed/isikzbeheu.js";
    script2.async = true;
    script2.type = "module";
    document.body.appendChild(script2);

    return () => {
      document.body.removeChild(script1);
      document.body.removeChild(script2);
    };
  }, []);

  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'ViewContent', {
        content_name: 'Video Page',
        content_category: 'Funnel'
      });
    }
  }, []);

  const handleBooking = () => {
    if (window.fbq) {
      window.fbq('track', 'Schedule');
    }
    navigate('/book');
  };

  const keyPoints = [
    "How to get 3000+ followers in 180 days",
    "The exact content strategy that generates 15-30 leads/month",
    "Why 95% of LinkedIn profiles fail to convert",
    "Our proven framework for LinkedIn authority"
  ];

  return (
    <div className="video-page">
      <div className="video-page-glow"></div>

      <div className="container">
        <div className="video-page-content">
          {/* Back Button */}
          <button onClick={() => navigate('/')} className="back-button">
            ← Back to Home
          </button>

          {/* Header */}
          <div className="video-page-header">
            <h1 className="video-page-title">
              Watch This Free Training to <span className="gradient-text">Transform Your LinkedIn</span>
            </h1>
            <p className="video-page-subtitle">
              Discover the exact system we use to build personal brands that generate consistent leads
            </p>
          </div>

          {/* Video Container */}
          <Card className="video-container">
            <div className="video-wrapper">
              <style>{`wistia-player[media-id='isikzbeheu']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/isikzbeheu/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }`}</style>
              <wistia-player media-id="isikzbeheu" aspect="1.7777777777777777"></wistia-player>
            </div>
          </Card>

          {/* Key Points */}
          <Card className="key-points-card">
            <h2 className="key-points-title">What You'll Learn:</h2>
            <div className="key-points-list">
              {keyPoints.map((point, index) => (
                <div key={index} className="key-point-item">
                  <CheckCircle2 className="w-6 h-6 key-point-icon" />
                  <span>{point}</span>
                </div>
              ))}
            </div>
          </Card>

          {/* CTA Section */}
          <div className="video-cta-section">
            <Card className="video-cta-card">
              <h2 className="video-cta-title">Ready to Get Started?</h2>
              <p className="video-cta-text">
                Book a free consultation call to discuss your LinkedIn growth strategy
              </p>
              <div className="video-cta-guarantee">
                <CheckCircle2 className="w-5 h-5" />
                <span>3000 followers & 15-30 leads in 180 days or we work for FREE</span>
              </div>
              <Button onClick={handleBooking} size="lg" className="cta-button-primary cta-button-large">
                Book Your Free Consultation
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
              <p className="video-cta-note">✓ No credit card required • ✓ 30-minute strategy session • ✓ Limited spots available</p>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoPage;